

export const resolveBarLayoutValues = (orderedCompanyPriceData, cpdActiveFields, numericChanges) => {
    console.log("[ENTERING STEP 2 - NEP TECHNIQUE - ORCHESTRATION BY ASSEMBLER]: Enrichment Step")
    console.log(`${"=".repeat(30)}`)

    // 1. The one shared scale every bar is measured off - 0 pinned to the middle of the track, so it sits in the same place for every list and every period,
    //    and each half of the track spans the list's biggest move, whichever way it went
    const zeroLine    = 50      // where 0 sits, as a % in from the left edge of the track
    const halfTrack   = 50      // % of the track each side of 0 gets - the biggest move fills its side
    const biggestMove = Math.max(0, ...numericChanges.map(Math.abs))
    // || 1: when nothing moved at all there is no move to divide by - this keeps the math defined, and every bar still comes out 0 wide
    const scaleSpan   = biggestMove || 1

    // 2. Each bar's left / width on that scale, keyed by company id: gains grow right from the zero line, losses grow left from it
    const placements = {}
    orderedCompanyPriceData.forEach((cpd) => {
        const change = cpd[cpdActiveFields.change]
        // IPO window rows (N/A) get no fill, so their label just starts at the zero line
        if (change === 'N/A') {
            placements[cpd.id] = { left: `${zeroLine}%`, width: '0%' }
            return
        }
        const width = (Math.abs(change) / scaleSpan) * halfTrack
        const left  = change >= 0 ? zeroLine : zeroLine - width
        placements[cpd.id] = { left: `${left}%`, width: `${width}%` }
    })

    // 3. Gutters (room for the value labels) are held on both sides of the track for every list - gains label to the right of their bar, losses to the left
    // An all-gainers or all-losers period keeps both too: dropping one would move the track, and with it the zero line in its middle
    const barGutter      = 'has-gains has-losses'

    return { placements, barGutter }
}
